import { useEffect, useState } from "react";
import { getMeta } from "../local/db";

// #645 — fallback freshness anchor for the "not live — last updated HH:MM"
// banner. The ride-status poll's own `lastUpdated` (packages/common-fe
// useRideStatuses) is the PRIMARY source once it has fired at least once this
// session. But an announcer can open the app already offline (e.g. a reload
// mid-dropout) before that poll ever succeeds — in that case the most honest
// timestamp we have is the setup-time prefetch (`local/prefetch.js` stamps
// `lastPrefetchedAt` into the IndexedDB meta store on every successful pull).
// Re-reads whenever prefetchStatus changes so a fresh prefetch updates it too.
export function useLastPrefetchedAt(prefetchStatusKey) {
  const [lastPrefetchedAt, setLastPrefetchedAt] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getMeta("lastPrefetchedAt").then((value) => {
      if (!cancelled && value) setLastPrefetchedAt(value);
    });
    return () => {
      cancelled = true;
    };
  }, [prefetchStatusKey]);
  return lastPrefetchedAt;
}

export default useLastPrefetchedAt;
